/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery, useQueryClient } from 'react-query';
import {
  useEditMutation,
  usePageQuery,
  useCreateMutation,
  useDeleteMutation,
} from './usePageQuery';

import {
  getAllLocations,
  getLocations,
  updateLocation,
  createLocation,
  closeLocation,
} from '~/api/locations';
import { locations } from '~/routes';
import { Location } from '~/types';

export const useAllLocations = () => {
  return useQuery<Location[]>([locations], () => getAllLocations().then((res) => res.data), {
    staleTime: 60 * 1000,
  });
};

export const useLocationsQuery = (options?: any) => {
  return usePageQuery<Location[]>(locations, getLocations, options);
};

export const useLocationsEdit = (closeParent?: () => void) => {
  const queryClient = useQueryClient();
  return useEditMutation(locations, updateLocation, {
    onMutate: closeParent,
    onSuccess() {
      void queryClient.invalidateQueries(locations);
    },
  });
};

export const useLocationsCreate = (closeParent: () => void) => {
  const queryClient = useQueryClient();
  return useCreateMutation(locations, createLocation, {
    onMutate: closeParent,
    onSuccess() {
      void queryClient.invalidateQueries(locations);
    },
  });
};

export const useLocationsDelete = (closeParent: () => void) => {
  const queryClient = useQueryClient();
  return useDeleteMutation(locations, closeLocation, {
    onMutate: closeParent,
    onSuccess() {
      void queryClient.invalidateQueries(locations);
    },
  });
};
